exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-panel {\n  width: 100%;\n  padding: 10px;\n  min-height: 150px;\n  color: var(--grey-700);\n  background-color: var(--grey-100);\n  border: 5px solid var(--grey-400);\n  font-family: var(--base-font-family);\n  font-size: 13px;\n  position: relative;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/detail-panel/styles.css
// module id = 2327
// module chunks = 29